import { Container, Graphics, Text } from 'pixi.js';
import { UI_COLORS, UI_TEXT_STYLES } from './Theme';

export interface PanelOptions {
  width: number;
  height: number;
  title?: string;
  padding?: number;
  radius?: number;
  alpha?: number;
}

export class Panel extends Container {
  public readonly content = new Container();
  private readonly background = new Graphics();
  private readonly titleText = new Text({
    text: '',
    style: UI_TEXT_STYLES.panelTitle
  });

  private panelWidth: number;
  private panelHeight: number;
  private readonly padding: number;
  private readonly radius: number;
  private readonly panelAlpha: number;

  public constructor(options: PanelOptions) {
    super();
    this.panelWidth = options.width;
    this.panelHeight = options.height;
    this.padding = options.padding ?? 28;
    this.radius = options.radius ?? 8;
    this.panelAlpha = options.alpha ?? 0.94;

    this.addChild(this.background);
    this.addChild(this.titleText);
    this.addChild(this.content);
    this.setTitle(options.title ?? '');
    this.draw();
  }

  public setTitle(title: string): void {
    this.titleText.text = title;
    this.titleText.visible = title.length > 0;
    this.layout();
  }

  public setSize(width: number, height: number): void {
    this.panelWidth = width;
    this.panelHeight = height;
    this.draw();
  }

  public getSize(): { width: number; height: number } {
    return {
      width: this.panelWidth,
      height: this.panelHeight
    };
  }

  private draw(): void {
    this.background.clear();
    this.background
      .roundRect(0, 0, this.panelWidth, this.panelHeight, this.radius)
      .fill({ color: UI_COLORS.paper, alpha: this.panelAlpha })
      .stroke({ color: UI_COLORS.gold, width: 2, alpha: 0.72 });
    this.background.rect(0, 0, this.panelWidth, 7).fill({ color: UI_COLORS.red, alpha: 0.88 });
    this.background
      .rect(this.padding, 54, this.panelWidth - this.padding * 2, 1)
      .fill({ color: UI_COLORS.gold, alpha: 0.34 });
    this.layout();
  }

  private layout(): void {
    this.titleText.position.set(this.padding, 22);
    this.content.position.set(this.padding, this.titleText.visible ? 78 : this.padding);
  }
}
